import { render, staticRenderFns } from "./DashboardAlbaranesRanking.vue?vue&type=template&id=67e5e3be&scoped=true&lang=pug"
import script from "./DashboardAlbaranesRanking.vue?vue&type=script&lang=js"
export * from "./DashboardAlbaranesRanking.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlbaranesRanking.vue?vue&type=style&index=0&id=67e5e3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5e3be",
  null
  
)

export default component.exports